import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import { Menu, X, Trees } from "lucide-react";
import AboutUs from './components/AboutUs';
import Courses from './components/Courses';
import Articles from './components/Articles';
import ContactUs from './components/ContactUs';
import RegisterForm from './components/RegisterForm';
import RegistrationsList from './components/RegistrationsList';
import UpdateRegistration from './components/UpdateRegistration';
import "./App.css";

const App: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (navRef.current && !navRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };

    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscapeKey);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <Router>
      <div className="app-shell">
        <header className="site-header" ref={navRef}>
          <div className="header-inner">
            <Link to="/" className="brand" onClick={handleLinkClick}>
              <Trees className="brand-icon" />
              <div className="brand-text">
                <span className="brand-title">森林學校</span>
                <span className="brand-subtitle">Forest School</span>
              </div>
            </Link>

            <button
              className="menu-toggle"
              onClick={toggleMenu}
              aria-label="切換選單"
              aria-expanded={menuOpen}
            >
              {menuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>

            <nav className={`site-nav ${menuOpen ? "open" : ""}`}>
              <ul>
                <li>
                  <Link to="/about" onClick={handleLinkClick}>
                    關於森林學校
                  </Link>
                </li>
                <li>
                  <Link to="/courses" onClick={handleLinkClick}>
                    活動 Courses
                  </Link>
                </li>
                <li>
                  <Link to="/articles" onClick={handleLinkClick}>
                    分享 Articles
                  </Link>
                </li>
                <li>
                  <Link to="/contact" onClick={handleLinkClick}>
                    聯絡 ContactUs
                  </Link>
                </li>
                <li>
                  <Link to="/register" onClick={handleLinkClick} className="nav-cta">
                    報名 Registrations
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </header>

        <main className="page-content">
          <Routes>
            <Route path="/" element={<AboutUs />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/register" element={<RegisterForm />} />
            <Route path="/update/:id" element={<UpdateRegistration />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
};

export default App;